export default function YoutubeAdBanner() {
    return (
        <div className="max-w-6xl mx-auto px-4 my-4">
            <div
                className="
          flex flex-col md:flex-row
          items-start md:items-center
          justify-between
          gap-4
          px-5 py-4
          rounded-xl
          bg-gradient-to-r from-indigo-800 via-purple-800 to-fuchsia-800
          border border-white/10
          shadow-md
        "
            >
                {/* LEFT */}
                <div>
                    <p className="text-blue-300 text-[11px] font-semibold uppercase mb-0.5">
                        Sponsored
                    </p>

                    <p className="text-white text-sm font-semibold leading-snug">
                        🚀 Learn Python & Tech on YouTube
                    </p>

                    <p className="text-indigo-100 text-xs leading-snug max-w-md">
                        Short Python tutorials, coding memes & real tech news.
                    </p>
                </div>

                {/* BUTTON */}
                <a
                    href="https://youtube.com/@aicodepath"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="
            inline-flex items-center gap-1.5
            bg-red-600 hover:bg-red-700
            text-white text-xs font-semibold
            px-4 py-2
            rounded-full
            shadow
            whitespace-nowrap
          "
                >
                    ▶ Subscribe
                </a>
            </div>
        </div>
    );
}
